import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import IndicatorUtils from "../../utils/IndicatorUtils";
import axios from "axios";
import {selectIndicator} from "../../actions/indicators";
import {addLayer, removeLayer} from "qwc2/actions/layers";
import FileUtils from "../../utils/FileUtils";
import LocalUtils from "qwc2/utils/LocaleUtils";

class IndicatorTimeslices extends React.Component {
    static propTypes = {
        addLayer: PropTypes.func,
        removeLayer: PropTypes.func,
        selectIndicator: PropTypes.func,
        selectedDate: PropTypes.string,
        selectedIndicator: PropTypes.object,
        selectedObjectType: PropTypes.string
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true,
            url: null
        };
    }

    getTimeClass(slice) {
        if (this.isTimeActive(slice)) {
            return 'active';
        }
        return '';
    }

    isTimeActive(slice) {
        slice = IndicatorUtils.normalizeDate(slice);
        return this.props.selectedDate === slice;
    }

    updateChart() {
        const url = IndicatorUtils.getDevelopmentUrl(this.props.selectedIndicator, this.props.selectedObjectType);
        const self = this;
        axios(url).then(response => {
            self.setState({
                data: response.data,
                isLoading: false,
                url: url
            });
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    componentDidMount() {
        this.updateChart();
    }

    componentDidUpdate() {
        const url = IndicatorUtils.getDevelopmentUrl(this.props.selectedIndicator, this.props.selectedObjectType);
        if (url !== this.state.url) {
            this.updateChart();
        }
    }

    selectIndicator(slice) {
        if (this.props.selectedIndicator) {
            const oldLayer = IndicatorUtils.getLayer(this.props.selectedIndicator, this.props.selectedObjectType, this.props.selectedDate);
            this.props.removeLayer(oldLayer.id);
        }

        const date = IndicatorUtils.normalizeDate(slice);
        const layer = IndicatorUtils.getLayer(this.props.selectedIndicator, this.props.selectedObjectType, date);

        this.props.addLayer(layer);
        this.props.selectIndicator(this.props.selectedIndicator, this.props.selectedObjectType, date);
    }

    render() {
        return (
            <>
                {this.renderTable()}
                {this.renderDetails()}
                {this.renderDownload()}
            </>
        );
    }

    getDataForDate(date) {
        if (!this.state.data) {
            return null;
        }
        const compareDate = 'DATE_' + IndicatorUtils.normalizeDate(date);
        for (let i = 0; i < this.state.data.length; i++) {
            const set = this.state.data[i];
            if (set[compareDate]) {
                return set[compareDate];
            }
        }

        return null;
    }

    renderDetails() {
        const details = this.getDataForDate(this.props.selectedDate);
        if (!details) {
            console.log('No data for date', this.props.selectedDate);
            return null;
        }

        return (
            <div className="indicator-timedetails">
                <b>Metriken für {this.props.selectedDate} </b>
                <table className="attribute-list">
                    <tbody>
                    <tr>
                        <td className="identify-attr-title"><i>{LocalUtils.tr('indicators.count')}</i></td>
                        <td className="identify-attr-value">{details.count}</td>
                    </tr>
                    <tr>
                        <td className="identify-attr-title"><i>{LocalUtils.tr('indicators.maximum')}</i></td>
                        <td className="identify-attr-value">{details.max}</td>
                    </tr>
                    <tr>
                        <td className="identify-attr-title"><i>{LocalUtils.tr('indicators.minimum')}</i></td>
                        <td className="identify-attr-value">{details.min}</td>
                    </tr>
                    {details.mean && (
                        <tr>
                            <td className="identify-attr-title"><i>{LocalUtils.tr('indicators.average')}</i></td>
                            <td className="identify-attr-value">{details.mean.toFixed(2)}</td>
                        </tr>
                    )}
                    {details.median && (
                        <tr>
                            <td className="identify-attr-title"><i>{LocalUtils.tr('indicators.median')}</i></td>
                            <td className="identify-attr-value">{details.median.toFixed(2)}</td>
                        </tr>
                    )}
                    {details.sum && (
                        <tr>
                            <td className="identify-attr-title"><i>{LocalUtils.tr('indicators.sum')}</i></td>
                            <td className="identify-attr-value">{details.sum.toFixed(2)}</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        );
    }
    runDownload(format) {
        let url = IndicatorUtils.getDataUrl(
            this.props.selectedIndicator,
            this.props.selectedObjectType,
            this.props.selectedDate,
            undefined,
        ) + '&crs=EPSG:4326&bbox-crs=EPSG:4326';

        if (format === 'csv') {
            url += '&format=csv';
        }

        const fileName = `indicators-${this.props.selectedObjectType}-${this.props.selectedIndicator.id}-${this.props.selectedDate}.${format}`;
        axios(url).then(response => {
            if (format === 'csv') {
                FileUtils.downloadCsv(fileName, response.data);
            } else {
                // axios does json decode on response.data automatically, but thankfully geojson is valid json.
                FileUtils.downloadJson(fileName, response.data);
            }
        });
    }

    renderDownload() {
        return (
            <div
                className="timeslice-download-buttons"
            >
                <button
                    className="button"
                    onClick={ () => this.runDownload('geojson') }
                >
                    {LocalUtils.tr('indicators.downloadgeojson')}
                </button>
                <button
                    className="button"
                    onClick={ () => this.runDownload('csv') }
                >
                    {LocalUtils.tr('indicators.downloadcsv')}
                </button>
            </div>
        );

    }

    renderTable() {
        const slices = IndicatorUtils.getTimeSlices(this.props.selectedIndicator);
        return (
            <table className="indicator-timeslices">
                <thead>
                <tr>
                    <th>Datum</th>
                </tr>
                </thead>
                <tbody>
                {slices.map(slice => {
                    return (
                        <tr key={"slice-" + slice}>
                            <td>
                                    <span className={this.getTimeClass(slice)}
                                          onClick={() => this.selectIndicator(slice)}>
                                        {IndicatorUtils.normalizeDate(slice)}
                                    </span>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        );
    }
}

const selector = (state) => ({
    selectedIndicator: state.indicators.selectedIndicator,
    selectedObjectType: state.indicators.selectedObjectType,
    selectedDate: state.indicators.selectedDate
});

export default connect(selector, {
    selectIndicator: selectIndicator,
    addLayer: addLayer,
    removeLayer: removeLayer
})(IndicatorTimeslices);
